export const STUDIO_BASE_URL = 'https://studio.moonchild.ai';
export const VITE_FORGE_URL = import.meta.env.VITE_FORGE_URL.endsWith('/')
	? import.meta.env.VITE_FORGE_URL.slice(0, -1)
	: import.meta.env.VITE_FORGE_URL;
